import { useEffect, useMemo, useState } from 'react';
import { debounce } from '../debounce';

export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const debounced = useMemo(
    () =>
      debounce((val: T) => {
        setDebouncedValue(val);
      }, delay),
    [delay],
  );

  useEffect(() => {
    debounced(value);
  }, [value, debounced]);

  return debouncedValue;
}
